import styles from './social.module.css';
import fbLogo from '../../media/fblogo.png';
import igLogo from '../../media/iglogo.webp';
import mcLogo from '../../media/mclogo.png';

const Social = () => {
    return (
        <div className={styles.socialContainer}>
            <a href="https://www.facebook.com/groups/1404874386453337" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src={fbLogo} alt="Facebook" /> /abaerferdsla
            </a>
            <a href="https://www.instagram.com/sukkla.fo/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src={igLogo} alt="Instagram" /> /sukkla.fo
            </a>
            <a href="https://www.facebook.com/hjolvelting/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src={fbLogo} alt="Facebook" /> /hjolvelting
            </a>
            <a href="https://sukkla.fo/limir" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src={mcLogo} alt="tidindabraev" /> /tidindabraev
            </a>
        </div>
    );
};

export default Social;